import React from 'react';
import styled from 'styled-components';

import { Button } from '@vimeo/iris/components';
import { DownloadArrow } from '@vimeo/iris/icons';
import { themes } from '@vimeo/iris/themes';
import { Paragraph } from '@vimeo/iris/typography';

import { UserPlaceholder, ClipPlaceholder, AlbumThemes } from '../../types';
import { THEME_DARK } from '../../utils/constants';
import { ClipCardWrapper, ClipTitle, DescriptionBox } from '../ClipCard/Styles';
import { ThumbnailImage, UserName } from '../UserLink/Styles';
import { ImagePlaceholder, UserBlock } from './Styles';

interface Props {
  video: ClipPlaceholder;
  user: UserPlaceholder;
  theme: AlbumThemes;
  allowDownloads: boolean;
}

const ClipCardWrapperStyled = styled(ClipCardWrapper)`
  background: transparent;
`;

const DownloadWrapper = styled.div`
  position: absolute;
  right: 10px;
  bottom: 12px;
`;

const StyledDownloadIcon = styled(DownloadArrow)<{ isDarkTheme: boolean }>`
  path {
    fill: ${(props) => (props.isDarkTheme ? 'white' : undefined)};
  }
`;

export default function VideoCardPlaceholder({ video, user, theme, allowDownloads }: Props) {
  const thumbnails: string[] = user.pictures.map((thumb) => `${thumb.link} ${thumb.width}w`);

  const isDarkTheme = theme === THEME_DARK;

  return (
    <ClipCardWrapperStyled>
      <ImagePlaceholder image={video.picture && video.picture.link} />
      <DescriptionBox darkTheme={isDarkTheme}>
        <ClipTitle>{video.name}</ClipTitle>
        <UserBlock>
          <ThumbnailImage src={thumbnails[0]} srcSet={thumbnails.join(', ')} alt="" />
          <UserName>{user.name}</UserName>
        </UserBlock>
        <Paragraph size="2">{video.description}</Paragraph>
        {allowDownloads && video.privacy.download && (
          <DownloadWrapper>
            <Button
              icon={<StyledDownloadIcon isDarkTheme={isDarkTheme} />}
              format="soft"
              variant="minimalTransparent"
              theme={isDarkTheme ? themes.dark : themes.light}
              size="md"
            />
          </DownloadWrapper>
        )}
      </DescriptionBox>
    </ClipCardWrapperStyled>
  );
}
